import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";

const baseUrl = "/api/";

@Injectable({ providedIn: "root" })
export class CrudService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private translateService: TranslateService
  ) {}

  get(payload, callback, url) {
    let pUrl = url && url.startsWith("http") ? url : baseUrl + url;
    return this.http.get(pUrl).subscribe(
      (response) => {
        // console.log(response);
        if (callback) callback(response);
      },
      (error) => {
        console.log("ERROR IN GET", error);
        if (callback) callback(error);
      }
    );
  }

  post(payload, callback, url) {
    let pUrl = url && url.startsWith("http") ? url : baseUrl + url;
    return this.http.post(pUrl, payload).subscribe(
      (response) => {
        if (callback) callback(response);
      },
      (error) => {
        if (
          error &&
          error.error &&
          error.error.message &&
          error.error.message ==
            "Insufficient privileges to perform this action. Please contact your system administrator for assistance"
        ) {
          this.toastr.error(
            this.translateService.instant("Form.Error.InsufficientPrivilege"),
            "Invalid Operation"
          );
        } else {
          if (callback) callback(error);
        }
      }
    );
  }

  update(payload, callback, url) {
    let pUrl = url && url.startsWith("http") ? url : baseUrl + url;
    return this.http.patch(pUrl, payload).subscribe(
      (response) => {
        console.log(response);
        if (callback) callback(response);
      },
      (error) => {
        console.log(error);
        if (callback) callback(error);
      }
    );
  }

  delete(payload, callback, url) {
    let pUrl = url && url.startsWith("http") ? url : baseUrl + url;
    return this.http.delete(pUrl).subscribe(
      (response) => {
        console.log(response);
        if (callback) callback(response);
      },
      (error) => {
        console.log(error);
        if (callback) callback(error);
      }
    );
  }
}
